var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoty3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16L15 31V62H49V31L32 16Z",
    stroke: "#07213A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0V9",
    stroke: "#07213A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.92 9.07996L47.56 15.44",
    stroke: "#07213A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.08 9.07996L16.44 15.44",
    stroke: "#07213A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 46H26V62H38V46Z",
    stroke: "#07213A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 62H64",
    stroke: "#07213A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoty3);
export default __webpack_public_path__ + "static/media/categoty3.e3436622cc72e40599f87a9e9e477a45.svg";
export { ForwardRef as ReactComponent };